require('../../upsales/domain/account/account.js');
require('../../upsales/domain/account/controllers/editAccount.js');
require('../../upsales/domain/account/controllers/account.js');
require('../../upsales/domain/account/controllers/accountDashboard.js');
require('../../upsales/domain/account/controllers/accountActivities.js');
require('../../upsales/domain/account/controllers/accountOpportunities.js');
require('../../upsales/domain/account/controllers/accountMarket.js');
require('../../upsales/domain/account/controllers/accountOrders.js');
require('../../upsales/domain/account/controllers/accountAddresses.js');
require('../../upsales/domain/account/controllers/accountFiles.js');
require('../../upsales/domain/account/controllers/accountApps.js');
require('../../upsales/domain/account/meta/editAccount.js');
require('../../upsales/domain/account/meta/account.js');
require('../../upsales/domain/account/controllers/accountUdo.js');

require('../../upsales/domain/activity/activity.js');
require('../../upsales/domain/activity/controllers/listActivities.js');

require('../../upsales/domain/order/order.js');
require('../../upsales/domain/order/controllers/editOrder.js');
require('../../upsales/domain/order/controllers/updateOrderMulti.js');
require('../../upsales/domain/order/meta/editOrder.js');
require('../../upsales/domain/order/meta/updateOrderMulti.js');

require('../../upsales/domain/agreement/agreement.js');
require('../../upsales/domain/agreement/controllers/editAgreement.js');
require('../../upsales/domain/agreement/meta/editAgreement.js');

require('../../upsales/domain/opportunity/opportunity.js');
require('../../upsales/domain/opportunity/controllers/listPeriodizations.js');

require('../../upsales/domain/activity/controllers/editActivity.js');
require('../../upsales/domain/activity/meta/editActivity.js');

require('../../upsales/domain/appointment/appointment.js');
require('../../upsales/domain/appointment/controllers/listAppointment.js');

require('../../upsales/domain/contact/contact.js');
require('../../upsales/domain/contact/controllers/editContact.js');
require('../../upsales/domain/contact/controllers/contact.js');
require('../../upsales/domain/contact/controllers/contactDashboard.js');
require('../../upsales/domain/contact/controllers/contactActivities.js');
require('../../upsales/domain/contact/controllers/contactOpportunities.js');
require('../../upsales/domain/contact/controllers/contactOrder.js');
require('../../upsales/domain/contact/controllers/contactMarket.js');
require('../../upsales/domain/contact/controllers/contactRelations.js');
require('../../upsales/domain/contact/controllers/editContactRelation.js');
require('../../upsales/domain/contact/controllers/contactFiles.js');
require('../../upsales/domain/contact/controllers/contactUdo.js');
require('../../upsales/domain/contact/meta/editContact.js');
require('../../upsales/domain/contact/meta/contact.js');

require('../../upsales/domain/lead/lead.js');
require('../../upsales/domain/lead/controllers/editLeads.js');
require('../../upsales/domain/lead/meta/editLead.js');

require('../../upsales/domain/campaign/campaign.js');
require('../../upsales/domain/campaign/controllers/campaign.js');
require('../../upsales/domain/campaign/controllers/campaignDashboard.js');
require('../../upsales/domain/campaign/controllers/campaignSocialEvents.js');
require('../../upsales/domain/campaign/controllers/campaignContacts.js');
require('../../upsales/domain/campaign/controllers/campaignActivities.js');
require('../../upsales/domain/campaign/controllers/campaignAppointments.js');
require('../../upsales/domain/campaign/controllers/campaignOpportunities.js');
require('../../upsales/domain/campaign/controllers/campaignOrder.js');
require('../../upsales/domain/campaign/controllers/campaignAccounts.js');
require('../../upsales/domain/campaign/controllers/campaignForms.js');
require('../../upsales/domain/campaign/controllers/campaignMailinglists.js');
require('../../upsales/domain/campaign/meta/campaign.js');
require('../../upsales/domain/campaign/controllers/campaignUdo.js');

require('../../upsales/domain/admin/admin.js');
require('../../upsales/domain/admin/controllers/admin.js');
require('../../upsales/domain/admin/controllers/main.js');
require('../../upsales/domain/admin/controllers/settings/settings.js');
require('../../upsales/domain/admin/controllers/automations/editAction.js');

require('../../upsales/domain/admin/controllers/AddProductCategoryModal.js');

require('../../upsales/domain/mail/mail.js');

require('../../upsales/domain/soliditet/soliditet.js');
require('../../upsales/domain/soliditet/controllers/findProspects.js');

require('../../upsales/domain/form/form.js');
require('../../upsales/domain/form/controllers/formSubmit.js');
require('../../upsales/domain/form/meta/form.js');
require('../../upsales/domain/form/meta/formEditor.js');

require('../../upsales/domain/userdefinedobject/userdefobj.js');

require('../../upsales/domain/looker/looker.js');

require('../../upsales/domain/esign/esign.js');
require('../../upsales/domain/esign/controllers/listEsign.js');
require('../../upsales/domain/esign/controllers/editEsign.js');
require('../../upsales/domain/esign/meta/editEsign.js');

require('../../upsales/domain/segment/segment.js');
require('../../upsales/domain/segment/controllers/editSegment.js');

require('../../upsales/domain/segment/meta/editSegment.js');
